import axios from "axios";
import { AppDispatch } from "../store";
import { AccountInfo, IPublicClientApplication } from "@azure/msal-browser";
import { getApiUrl } from "../helpers/environmentHelper";
import { setIsWaitingIncomingOrderResponse, setIncomingOrders } from "../slices/statisticsSlice";
import { IncomingOrdersStatistics } from "../../models/responses/incomingOrdersStatistics";
import { acquireApiToken } from "../helpers/apiTokenHelper";
import { ClientType } from "../../models/enums/clientTypeEnum";

export const getIncomingOrders =
  (instance: IPublicClientApplication, account: AccountInfo | null, clientType: ClientType) =>
    async (dispatch: AppDispatch) => {
      const baseUrl = getApiUrl(window.location.hostname, 2);
      dispatch(setIsWaitingIncomingOrderResponse(true));

      try {
        if (account) {
          acquireApiToken(instance, account)
            .then(async (response) => {
              if (response) {
                const getData: IncomingOrdersStatistics = (
                  await axios.get(`${baseUrl}/statistics/incoming-order?clientType=${clientType}`, {
                    timeout: 10000,
                    headers: {
                      "Content-Type": "application/json",
                      Authorization: `Bearer ${response.accessToken}`,
                    },
                  })
                ).data;
                dispatch(setIncomingOrders({ incomingOrders: getData }));
                dispatch(setIsWaitingIncomingOrderResponse(false));
              }
            });
        }
      } catch (error) {
        dispatch(setIsWaitingIncomingOrderResponse(false));
        console.log(error);
      }
    };